import { useState } from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import GroomingFormComponent from "./form/GroomingFormComponent";

const LandiingButtons = ({ setOpenForm }) => {
  const location = useLocation();

  return (
    <>
      {location.pathname.toLowerCase() === "/pet-grooming-at-home/delhi-ncr" ? (
        <>
          {/* <div
            className="header-slider-button"
            onClick={() => setOpenForm(true)}
          >
            Book Package Now
          </div> */}

{/* <a href="#grooming">Book Package Now</a> */}

            <a href="#grooming">
              <div
            className="header-slider-butt"
            // onClick={() => setOpenForm(true)}
          >
           Book Package Now 
          </div>
          </a>

          <Link  className="header-landing-slider-button-call" to="tel:+919658189189" target="_blank">
            <i className="fa-solid fa-phone"></i> Book by Call
          </Link>
        </>
      ) : (
        <>
          <Link to="tel:9658-189-189" target="_blank">
            <i className="fa-solid fa-phone"></i> Book by Call
          </Link>
          <div
            className="header-slider-button"
            onClick={(e) => setOpenForm(true)}
          >
            Book an Appointment
          </div>
        </>
      )}
    </>
  );
};

const HeaderSlider = ({ landingComponent }) => {
  const [openForm, setOpenForm] = useState(false);

  // ---------------------------------
  var settings = {
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
  };

  const location = useLocation();
  console.log(location.pathname);

  return (
    <div>
      {openForm ? (
        <GroomingFormComponent
          landingComponent={landingComponent}
          setDynamicForm={setOpenForm}
        />
      ) : (
        ""
      )}
      <div>
        <Slider {...settings}>
          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-1">
              <div>
                <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                <div className="header-slider-text">
                  No matter what pet, taking care of them is an important part
                  of letting them know you love them.


                  
                </div>

                {/* <div>{location.pathname === "/" ? "sdsdsd":"hththtth"}</div> */}

                {/* <AppDownloadsComponent/> */}
                <div className="header-slider-buttons">
                  {/* <Link to={ location.pathname.toLowerCase() === "/pet-grooming-at-home/delhi-ncr" ? "tel:+919658189189":"tel:9658-189-189"} target="_blank"> */}

                  <LandiingButtons setOpenForm={setOpenForm} />

                  {/* <Link
                    to={
                      location.pathname.toLowerCase() ===
                      "/pet-grooming-at-home/delhi-ncr"
                        ? "tel:+919658189189"
                        : "tel:9658-189-189"
                    }
                    target="_blank"
                  >
                    <i className="fa-solid fa-phone"></i> Book by Call
                  </Link>
                  <div
                    className="header-slider-button"
                    onClick={(e) => setOpenForm(true)}
                  >
                    Book an Appointment
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-2">
              <div>
                 <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                
                <div className="header-slider-text">
                  Our experienced professional Get Your Pet Groomed and give
                  them plenty of attention and love.
                </div>
                {/* <AppDownloadsComponent/> */}

                <div className="header-slider-buttons">
                  <LandiingButtons setOpenForm={setOpenForm} />
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-3">
              <div>
                <h1>
                  <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                </h1>

                <div className="header-slider-text">
              Your Pet Deserves The Best Care Qualified Personal Take care Your Pets Get Your Pet Groomed With Care And Love

                </div>
                {/* <AppDownloadsComponent/> */}

                <div className="header-slider-buttons">
                  <LandiingButtons setOpenForm={setOpenForm} />
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-1">
              <div>
                  <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                <div className="header-slider-text">
                  No matter what pet, taking care of them is an important part
                  of letting them know you love them.
                </div>
                {/* <AppDownloadsComponent/> */}

                <div className="header-slider-buttons">
                  <LandiingButtons setOpenForm={setOpenForm} />
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-2">
              <div>
                <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                <div className="header-slider-text">
                  Our experienced professional Get Your Pet Groomed and give
                  them plenty of attention and love.
                </div>
                {/* <AppDownloadsComponent/> */}

                <div className="header-slider-buttons">
                  <LandiingButtons setOpenForm={setOpenForm} />
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}

          <div>
            <div className="header-slider header-slider-3">
              <div>
                 <div className="header-slider-heading-1">Premium Pet Grooming </div>
                <div className="header-slider-heading-2">Packages at Home</div>
                <div className="header-slider-text">
              Your Pet Deserves The Best Care Qualified Personal Take care Your Pets Get Your Pet Groomed With Care And Love

                </div>
                {/* <AppDownloadsComponent/> */}

                <div className="header-slider-buttons">
                  <LandiingButtons setOpenForm={setOpenForm} />
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------- */}
        </Slider>
      </div>
    </div>
  );
};

export default HeaderSlider;
